<template>
  <div>
    <data-table
      ref="table"
      :fetch-from="fetchForm"
      :fields="fields"
    >
      <template
        slot="actions"
        slot-scope="slotData"
      >
        <v-btn
          x-small
          color="primary"
          @click="showDetails(slotData.rowData)"
        >Edit</v-btn>
      </template>

      <template
        slot="nextChange"
        slot-scope="slotData"
      >
        <span
          v-bind:class="{ alert: isMoreThanDaysTillThen(slotData.rowData) }"
        >
          {{ dateOfNextChangeForItem(slotData.rowData) }}
        </span>
      </template>
    </data-table>
    <actions v-if="canEdit()">
      <v-btn
        color="primary"
        class="mr-4"
        small
        @click="showAddDialog()"
      >
        Add new
      </v-btn>
    </actions>
    <empty-space />
    <modal-form
      title="DC System"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
      :readonly="isReadOnly()"
    >
      <v-container>
        <v-form v-model="valid">
          <v-row>
            <v-col cols="4">
              <d-c-system-type
                :codelist="true"
                :readonly="isReadOnly()"
                label="DC system type"
                :value="getValue(item, 'dc_system_type')"
                @input="setValue(item, 'dc_system_type', $event)"
              ></d-c-system-type>
            </v-col>
            <v-col cols="4">
              <d-c-system-status
                :readonly="isReadOnly()"
                label="DC system status"
                :value="getValue(item, 'dc_status')"
                @input="setValue(item, 'dc_status', $event)"
              ></d-c-system-status>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Production year"
                :value="getValue(item, 'production_year')"
                @input="setValue(item, 'production_year', $event)"
              ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnly()"
                label="1st instalation"
                :value="getValue(item, 'first_installation')"
                @input="setValue(item, 'first_installation', $event)"
              />
            </v-col>
            <v-col cols="4">
              <new-used
                :readonly="isReadOnly()"
                label="New/used"
                :value="getValue(item, 'new_used')"
                @input="setValue(item, 'new_used', $event)"
              ></new-used>
            </v-col>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnly()"
                label="Last instalation"
                :value="getValue(item, 'last_instalation')"
                @input="setValue(item, 'last_instalation', $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnly()"
                label="Removed date"
                :value="getValue(item, 'removed_date')"
                @input="setValue(item, 'removed_date', $event)"
              />
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="To change in (year)"
                :value="getValue(item, 'to_change_in_years')"
                @input="setValue(item, 'to_change_in_years', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <display-field label="Date of next change">{{ dateOfNextChange }}</display-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <switch-button
                :readonly="isReadOnly()"
                label="WEB access"
                :value="getValue(item, 'web_access')"
                @change="setValue(item, 'web_access', $event)"
              ></switch-button>
            </v-col>
            <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="WEB IP adress"
              :value="getValue(item, 'web_ip_address')"
              @input="setValue(item, 'web_ip_address', $event)"
            ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
            <s-textarea
              :readonly="isReadOnly()"
              label="Comments"
              :value="getValue(item, 'comments')"
              @input="setValue(item, 'comments', $event)"
            >
            </s-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </modal-form>
  </div>
</template>

<script>
  import DataTable from '@/components/DataTable'
  import Actions from '@/components/Actions'
  import EmptySpace from '@/components/EmptySpace'
  import ModalForm from '@/components/ModalForm'
  import TextField from '@/components/TextField'
  import DatePicker from '@/components/DatePicker'
  import NewUsed from '@/components/codelist/NewUsed'
  import DisplayField from '@/components/DisplayField'
  import DCSystemType from '@/components/codelist/DCSystemType'
  import DCSystemStatus from '@/components/codelist/DCSystemStatus'
  import SwitchButton from '@/components/SwitchButton'
  import ConstructionDCSystemService from '@/services/construction-dc-system'
  import ReactivitMixin from '@/mixins/Reactivity'
  import STextarea from '@/components/Textarea'
  import PermissionsMixin from '@/mixins/Permissions'
  import Utils from '@/utils'

  export default {
    name: 'DCSystem',
    mixins: [
      ReactivitMixin,
      PermissionsMixin,
    ],
    components: { STextarea, SwitchButton, DCSystemType, DisplayField, NewUsed, DatePicker, TextField, ModalForm, EmptySpace, Actions, DataTable, DCSystemStatus },
    props: {
      site: {
        default: undefined,
      },
    },
    data: function () {
      return {
        item: {},
        dialog: false,
        fields: [
          {
            name: 'dc_system_type_name',
            title: 'DC system Type',
          },
          {
            name: 'dc_status_name',
            title: 'DC status',
          },
          {
            name: 'production_year',
            title: 'Production year',
          },
          {
            name: 'first_installation',
            title: '1st instalation',
          },
          {
            name: '__slot:nextChange',
            title: 'Date of next change',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
        section: 'construction_equipment',
      }
    },
    computed: {
      isEditing () {
        return this.item.id !== undefined
      },
      dateOfNextChange () {
        return Utils.getNextDateInYearsFormatted(this.item.first_installation, this.item.last_instalation, this.item.to_change_in_years)
      },
    },
    methods: {
      isMoreThanDaysTillThen (item) {
        return Utils.isMoreThanDaysTillThen(Utils.getNextDateInYears(item.first_installation, item.last_instalation, item.to_change_in_years), 365)
      },
      fetchForm (urls, options) {
        const dcs = new ConstructionDCSystemService(this.site.id)
        return dcs.list(options.params)
      },
      showAddDialog () {
        this.item = {
          to_change_in_years: 15,
        }
        this.dialog = true
      },
      showDetails (item) {
        this.item = JSON.parse(JSON.stringify(item))
        this.dialog = true
      },
      dateOfNextChangeForItem (item) {
        return Utils.getNextDateInYearsFormatted(item.first_installation, item.last_instalation, item.to_change_in_years)
      },
      doSave () {
        if (this.isEditing) {
          const acs = new ConstructionDCSystemService(this.site.id)
          acs.put(this.item.id, this.item).finally(() => {
            this.$refs.table.refresh()
            this.dialog = false
          })
        } else {
          const acs = new ConstructionDCSystemService(this.site.id)
          acs.post(this.item).finally(() => {
            this.$refs.table.refresh()
            this.dialog = false
          })
        }
      },
    },
  }
</script>

<style scoped>
.alert {
  background-color: red;
  padding: 2px;
  color: white;
  border-radius: 5px;
  padding: 2px 5px 2px 5px;
}
</style>
